<template>
	<article class="pages_wrap">
		<article class="member-login">
			<section class="member-container">
				<div class="head-portrait">
					<img :src="HeadPic != null && HeadPic != '' ? HeadPic : '/../static/img/defaultdriverheadpic.jpg'" alt="" />
					<span></span>
				</div>

				<section class="inputs_wrap member-info">
					<!-- <section class="inputs_wrap input-info"> -->
					<div>
						<span>姓名</span>
						<input type="text" v-model="RealName" class="input-info" placeholder="请输入真实姓名" />
					</div>
					<!-- </section> -->

					<!-- <section class="inputs_wrap input-info"> -->
					<div>
						<span>身份证</span>
						<input type="text" v-model="IDCard" class="input-info" placeholder="请输入证件号码" />
					</div>
					<!-- </section> -->

					<!-- <section class="inputs_wrap input-info"> -->
					<div>
						<span>手机号码</span>
						<input type="text" v-model="Mobile" class="input-info" placeholder="请输入手机号码" />
					</div>
					<!-- </section> -->

					<!-- <section class="inputs_wrap input-info"> -->
					<div>
						<span>车牌号</span>
						<input type="text" v-model="CarNO" class="input-info" placeholder="请输入车牌号码" />
					</div>
					<!-- </section> -->

					<!-- <section class="inputs_wrap input-info"> -->
					<div>
						<span>行政区</span>
						<input type="text" v-model="District" class="input-info" placeholder="请选择住址所在行政区" readonly="true" @click="showDistrictSelection" />
					</div>
					<!-- </section> -->

					<!-- <section class="inputs_wrap input-info"> -->
					<div>
						<span>住址</span>
						<input type="text" v-model="Address" class="input-info" placeholder="派单出发地备选之一" />
					</div>
					<!-- </section> -->

					<!-- <section class="inputs_wrap input-info"> -->
					<div>
						<span>公司/跓点</span>
						<input type="text" v-model="CompanyAddress" class="input-info" placeholder="主要派单出发地" />
					</div>
					<!-- </section> -->
				</section>
			</section>

			<footer class="page-footer"><button @click="saveDriverInformation">提交信息</button></footer>
		</article>
	</article>
</template>

<script>
import { mapState } from 'vuex';
import driverApi from '@/request/driverApi';
export default {
	name: 'DriverInfoRegister',
	data() {
		return {
			HeadPic: '',
			RealName: '',
			IDCard: '',
			CarNO: '',
			Mobile: '',
			Sex: '男',
			Province: '广东省',
			City: '中山市',
			District: '',
			Address: '',
			CompanyAddress: '',
			pickupPlaceList: []
		};
	},
	activated() {
		this.getDriverData();
		this.getPickupPriceList();
	},
	methods: {
		getDriverData() {
			let that = this;
			this.tmpTimer = setInterval(() => {
				this.$Spin.show();
				if (this.OpenId && this.OpenId.length > 0) {
					clearInterval(this.tmpTimer);
					driverApi.getDriverData(this.OpenId).then(sucRes => {
						if (sucRes.success) {
							this.HeadPic = sucRes.data.HeadPic;
							this.RealName = sucRes.data.DriverName;
							this.IDCard = sucRes.data.IDCard;
							this.CarNO = sucRes.data.CarNO;
							this.Mobile = sucRes.data.Mobile;
							this.Sex = sucRes.data.Sex;
							this.Province = sucRes.data.Province;
							this.City = sucRes.data.City;
							this.District = sucRes.data.District;
							this.Address = sucRes.data.HomeAddress;
							this.Sex = sucRes.data.Sex;
							this.CompanyAddress = sucRes.data.CompanyAddress;
						}
						this.$Spin.hide();
					});
				}
			}, 500);
		},
		showDistrictSelection() {
			let that = this;
			let tmpArray = [];
			for (let i = 0; i < this.pickupPlaceList.length; i++) {
				let tmp = {
					label: this.pickupPlaceList[i].name,
					value: this.pickupPlaceList[i].name
				};
				tmpArray.push(tmp);
			}
			this.$weui.picker(tmpArray, {
				onConfirm(result) {
					that.District = result[0].value;
				}
			});
		},
		getPickupPriceList() {
			let that = this;
			this.pickupPlaceList = [];
			AMap.service('AMap.DistrictSearch', function() {
				//回调函数
				var opts = {
					subdistrict: 1, //返回下一级行政区
					level: 'city', //查询的范围
					showbiz: false //查询行政级别为 市
				};
				//实例化DistrictSearch
				let districtSearch = new AMap.DistrictSearch(opts);
				//TODO: 使用districtSearch对象调用行政区查询的功能
				districtSearch.search('中山市', function(status, result) {
					//TODO : 按照自己需求处理查询结果
					console.log(result);
					that.pickupPlaceList = result.districtList[0].districtList;
				});
			});
		},
		saveDriverInformation() {
			if (this.userData && this.userData.HeadPic && this.userData.HeadPic.length > 0) {
				this.HeadPic = this.userData.HeadPic;
			}
			if (this.RealName == '' || this.CardNO == '' || this.Mobile == '' || this.District == '') {
				alert('必要信息不完整，姓名，电话，车牌号，行政区必填。');
				return;
			}
			this.$Spin.show();
			driverApi
				.saveDriverInfo(
					this.OpenId,
					this.RealName,
					this.IDCard,
					this.CarNO,
					this.Mobile,
					this.District,
					this.Address,
					this.CompanyAddress,
					this.HeadPic,
					this.Sex,
					this.Province,
					this.City
				)
				.then(sucRes => {
					this.$Spin.hide();
					if (sucRes.success) {
						alert(sucRes.message);
						this.$router.replace({
							name: 'DriverMainPage'
						});
					} else alert(sucRes.message);
				});
		}
	},
	computed: mapState({
		userData: state => state.user.userData,
		OpenId: state => state.user.OpenId
	})
};
</script>

<style scoped lang="less">
@import '.././style/public';
@import '.././style/variable';

.pages_wrap,
.index_pages_wrap {
	width: 100%;
	height: 100%;
	position: relative;
	/* overflow: hidden; */
	overflow-x: hidden;
	/* overflow-y: auto; */
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.member-login {
	height: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.member-container {
	flex: 1;
	.overfA();
	padding: @headerPaddingLr;
	.head-portrait {
		.flex_wrap(center, center, nowrap, column);
		img {
			width: 2rem;
			height: 2rem;
			.radius(50%);
			margin-top: 10px;
			box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.8);
		}
		span {
			.marginTb();
			font-weight: 600;
			color: #666;
			text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
		}
	}
}

.inputs_wrap > div > input {
	padding-left: 8px;
	line-height: 0.8rem;
	border: none;
}

.member-info {
	border-radius: 5px;
	border: 1px solid #888;
}

.member-info > div {
	padding: 0.2rem 3%;
}

.inputs_wrap {
	& > div {
		// margin-top: 10px;
		.flex_wrap(flex-start);
		& > span {
			padding-right: 8px;
			border-right: 1px solid #888;
			text-align: right;
			.flex_items(22%, 0, 0);
		}
		& > input {
			padding-left: 8px;
			line-height: 0.8rem;
			border: none;
		}
		& > input:disabled {
			background-color: transparent;
		}
	}
}

.member-info {
	.radius();
	.border();
	& > div {
		// border: 1px solid #888;
		.input-padding(0.2rem, 3%);
	}
	& > div:nth-last-child(n + 2) {
		border-bottom: 1px solid #888;
	}
}

.public-order-input {
	width: 90%;
	margin: 0 auto;
}

.page-footer {
	display: flex;
	justify-content: initial;
	align-items: center;
	flex-wrap: initial;
	flex-direction: initial;
	border-top: 1px solid #ddd;
	background-color: #fff;
}
.page-footer button {
	flex: 1;
	line-height: 1.2rem;
	text-align: center;
	border: none;
	background-color: #E77618;
	color: #fff;
	border-top: 1px solid rgba(0, 0, 0, 0.2);
	font-size: 0.4rem;
}

.indexBotNav-wrap {
	background-color: #fff;
	.blockPadding();
	.fixedBot();
	.flex_wrap(center, center, initial, initial);

	a {
		text-align: center;
		line-height: 0.8rem;
		.flex_items();
	}
}
</style>



// WEBPACK FOOTER //
// src/components/DriverInfoRegister.vue